declare global {
    interface Window {
        subscriptionTypes: Array<string>;
    }
}

export function getsubscriptionTypes() {
    if (window.subscriptionTypes) {

        return window.subscriptionTypes;
    }

    return null;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-subscriptiontypes.ts